module.exports = __webpack_public_path__ + "static/media/min-chess.0c8c2b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/min-chess.jpg
// module id = 399
// module chunks = 0